import requests from "./httpService";
    const HistoryServices = {

  getAllHistory: async (body) => {
    return requests.get("admin/history", body);
  },
 

  getLastHistory : async(body) =>{
     return requests.get("admin/last_history",body);
  },

  getLastAdminHistory : async(body) =>{
    return requests.get("admin/last_admin_history",body);
 },
  getNonViewed: async(body) =>{
    return requests.get("admin/non_viewed_history",body);
 }
};


export default HistoryServices;
